export const PULL_TO_REFRESH_CONFIG = {
  TRIGGER_THRESHOLD_PX: 80,
  DRAG_RESISTANCE_FACTOR: 2.5,
  MAX_INDICATOR_DISTANCE_PX: 120,
  RELOAD_DELAY_MS: 800,
  TICK_DISPLAY_MS: 200,
  INDICATOR_REFRESHING_Y_PX: 16,
  INDICATOR_SIZE_PX: 38,
} as const;

export const PTR_STATE = {
  IDLE: 'idle',
  PULLING: 'pulling',
  READY: 'ready',
  REFRESHING: 'refreshing',
} as const;
